/*
 * Throttle function borrowed from:
 * Underscore.js 1.8.3
 * http://underscorejs.org
 * (c) 2009-2017 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 */

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration.
function throttle ( func, wait ) {
	let timeout, context, args, result;
	let previous = 0;

	const later = function() {
		previous = new Date().getTime();
		timeout = null;
		result = func.apply( context, args );
		if ( !timeout ) context = args = null;
	};

	const throttled = function() {
		const now = new Date().getTime();
		if ( !previous ) previous = now;
		const remaining = wait - ( now - previous );
		context = this;
		args = arguments;
		if ( remaining <= 0 || remaining > wait ) {
			if (timeout) {
				clearTimeout( timeout );
				timeout = null;
			}
			previous = now;
			result = func.apply( context, args );
			if ( !timeout ) context = args = null;
		} else if ( !timeout ) {
			timeout = setTimeout( later, remaining );
		}
		return result;
	};

	return throttled;
}

/*
 * Returns the scroll top of the page
 */
function getScrollPage(){
	return document.body.scrollTop || document.documentElement.scrollTop;
}

/*
 * Returns a boolean to know if we past the header
 */
function pastHeader(){
	return getScrollPage() > document.getElementsByClassName('header')[0].offsetHeight + 200;
}
